import { FC } from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { SECTION_PADDING } from '../../styles/theme';
import Slider from 'react-slick'; // ✅ react-slick
import HaistAICard, { HaistAICardProps } from './HaistAICard';
import SectionTitle from '../section-title';
import 'slick-carousel/slick/slick.css';

const featureCardsData: Omit<HaistAICardProps, 'index'>[] = [
  {
    title: 'Take a picture',
    description: 'Any vehicle issue. One click.',
    image: '/images/hosai_card1.png',
  },
  {
    title: 'Haist extracts insights',
    description: 'Quick solutions for all your vehicle concerns.',
    image: '/images/hosai_card2.png',
  },
  {
    title: 'Auto-builds a smart report',
    description: 'Any vehicle. One click.',
    image: '/images/hosai_card3.png',
  },
  {
    title: 'Sent via SMS or WhatsApp',
    description: 'Any vehicle. One click.',
    image: '/images/hosai_card4.png',
  },
];

const HaistAISection: FC = () => {
  const theme = useTheme();
  const useSlide = useMediaQuery(theme.breakpoints.down('xl'));

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: !isMobile,
  };

  return (
    <>
      {/* react-slick dot 커스텀 스타일 */}
      <style>
        {`
          .slick-dots li button:before {
            color: rgba(255,255,255,0.3);
            font-size: 10px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: block;
            content: '';
            background: rgba(255,255,255,0.3);
            margin: 0 auto;
          }
          .slick-dots li.slick-active button:before {
            color: #fff;
            background: #fff;
          }
          .slick-dots li {
            width: 10px;
            height: 10px;
          }
          .slick-dots {
            bottom: -32px;
          }
        `}
      </style>
      <Box
        sx={{
          py: SECTION_PADDING.py,
          px: SECTION_PADDING.px,
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: '#ECF2FA',
          width: '100%',
          gap: '40px',
        }}
      >
        <SectionTitle
          title={'Haist'}
          subtitle={`Save Time.${isMobile ? '\n' : ' '}Reduce Errors.${
            isMobile ? '\n' : ' '
          }Improve Trust.`}
        />

        <Box
          sx={{
            width: '100%',
            height: {
              xs: '700px',
              sm: '1181px',
              md: '1454px',
            },
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {/* 배경 블러 */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              height: {
                xs: '500px',
                sm: '850px',
                md: '974px',
              },
              borderRadius: '40px',
              background: '#073C79',
              width: '100%',
              overflow: 'hidden',
              margin: '0 auto',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                height: '974px',
                opacity: 0.85,
                background:
                  'radial-gradient(circle, #DFF9FF, #5AB1C5, #8DB0D9)',
                borderRadius: '50%',
                filter: 'blur(274px)',
              }}
            />
          </Box>

          {/* 배경 이미지 */}
          <Box
            sx={{
              left: { xs: '-16px', sm: 0 },
              right: 0,
              top: {
                xs: '0px',
                sm: '0px',
                md: '72px',
              },
              position: 'absolute',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src="/images/haist/section-bg.png"
              style={{ width: '100%', maxWidth: '900px', height: 'auto' }}
            />
          </Box>

          {/* 카드 영역 */}
          <Box
            sx={{
              position: 'absolute',
              bottom: '52px',
              left: '0px',
              right: '0px',
              width: '100%',
              margin: '0 auto',
            }}
          >
            {useSlide ? (
              <Slider {...sliderSettings}>
                {featureCardsData.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: {
                        xs: 'calc(100vw - 48px)',
                        sm: '402px',
                      },
                      minWidth: {
                        xs: 'auto',
                        sm: '402px',
                      },
                      maxWidth: {
                        xs: '100%',
                        sm: '402px',
                      },
                      padding: {
                        xs: '0 15px',
                        sm: '0 0 0 30px',
                      },
                    }}
                  >
                    <HaistAICard
                      index={index}
                      title={feature.title}
                      description={feature.description}
                      image={feature.image}
                    />
                  </Box>
                ))}
              </Slider>
            ) : (
              <Grid
                container
                spacing={'30px'}
                justifyContent="center"
                sx={{
                  px: '24px',
                }}
              >
                {featureCardsData.map((feature, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={index}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: 0,
                    }}
                  >
                    <HaistAICard
                      index={index}
                      title={feature.title}
                      description={feature.description}
                      image={feature.image}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HaistAISection;
